import { trpcErrorType } from "components/rpc/trpc-error-type";

export const isNoLongerSharedError = (error: unknown): boolean =>
    trpcErrorType(error) === "NOT_FOUND";
